import {FormattedMessage} from "react-intl";
import './css/FieldsPage.css'
import {fields} from "../fields";

export const FieldsPage = (props) => {
    props.onEnter();


    const rows = [];
    for (const property in fields) {
        rows.push(
            <tr>
                <td>{property}</td>
                <td><FormattedMessage id={fields[property].type}/></td>
                <td><FormattedMessage id={property}/></td>
            </tr>);
    }

    return (
        <div className="main-container">
            <table>
                <tbody>
                <tr>
                    <th><FormattedMessage id='Field name'/></th>
                    <th><FormattedMessage id='Field type'/></th>
                    <th><FormattedMessage id='Description'/></th>
                </tr>
                {rows}
                </tbody>
            </table>
        </div>
    )
}